var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBonusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 24H54v18h37c3 0 5-2 5-5v-7c0-3-3-6-6-6ZM6 24c-3 0-6 3-6 6v7c0 3 2 5 5 5h37V24H6Zm0 24v42c0 3 3 6 6 6h30V48H6Zm78 48c3 0 6-3 6-6V48H54v48h30ZM48 18h24c8 0 12-4 12-9s-4-9-12-9-14 4-18 8c-4-3-8-3-12 0-4-5-10-8-18-8S12 4 12 9s4 9 12 9h24Zm30-9c0 3-3 3-6 3H58c3-3 8-6 14-6 3 0 6 1 6 3ZM18 9c0-2 3-3 6-3 6 0 11 3 14 6H24c-3 0-6 0-6-3Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBonusIcon);
export default __webpack_public_path__ + "static/media/menu-bonus-icon.1d942a8451132429787fd97e2dba9239.svg";
export { ForwardRef as ReactComponent };